<template>
  <div class="header mb-5">
    <v-app-bar
      :app="$store.state.break_point <= 991"
      color="white"
      flat
      height="65"
    >
      <v-container class="py-0 align-center d-flex justify-space-between">
        <h1>Vinish</h1>

        <v-spacer></v-spacer>

        <div class="d-flex">
          <v-btn
            class="ms-3"
            v-if="$store.state.break_point <= 991 && $store.getters.loggedin"
            small
            icon
            @click="$store.state.drawer = !$store.state.drawer"
          >
            <v-icon>menu</v-icon>
          </v-btn>
        </div>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  data: () => ({}),
  methods: {},
  computed: {
    selectedLang() {
      const selected = this.$store.state.langs.data.find(
        (e) => e.locale == this.$store.state.dash_lang
      );
      return selected ? selected.name : "";
    },
  },
  methods: {
    selectLang(lang) {
      document.cookie = `locale=${lang.locale}`;
      this.$store.state.dash_lang = lang.locale;
    },
  },
};
</script>
